import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule, Router } from '@angular/router';
import { AuthGuard } from '../auth/_guards/auth.guard';
import { EntityResolverService } from '../_resolvers/entity-resolver.service';
import { PermissionGuard } from '../auth/_guards/permission.guard';
import { OracleWindowComponent } from './layouts/staff-assistant/oracle/oracle-window.component';
import { DaisyWindowComponent } from './layouts/staff-assistant/daisy/daisy-window.component';
import { RoomWindowComponent } from './layouts/staff-assistant/room/room-window.component';

const routes: Routes = [
	// Oracle's own window (Ask Firefly → "open in its own window"): outside the app frame.
	{
		path: 'oracle',
		component: OracleWindowComponent,
		canActivate: [AuthGuard, PermissionGuard],
		data: { permission: 'oracle.use' },
	},
	// Daisy's own window, likewise.
	{
		path: 'daisy',
		component: DaisyWindowComponent,
		canActivate: [AuthGuard, PermissionGuard],
		data: { permission: 'daisy.use' },
	},
	// The agent Room's own window, likewise.
	{
		path: 'room',
		component: RoomWindowComponent,
		canActivate: [AuthGuard, PermissionGuard],
		data: { permission: 'room.use' },
	},
	{
		path: '',
		component: ThemeComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: '',
				canActivate: [AuthGuard],
				loadChildren: () => import('./pages/default/iglo/iglo.module').then(m => m.IgloModule),
				resolve: {
					entity: EntityResolverService,
				},
			},
		],
	},
	{
		path: '**',
		redirectTo: '/404',
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ThemeRoutingModule {}
